<template>
  <label
    v-if="isOnboardingRedesign"
    class="
      tw-border tw-border-solid tw-relative
      hover:tw-border-[#1A6A72]
      tw-py-3 tw-px-5 tw-rounded-xl
      tw-overflow-hidden
      tw-cursor-pointer tw-space-y-4
    "
    :class="[
      model === item.id ? 'tw-border-[#1A6A72]' : 'tw-border-[#C7C7C7]',
      disabled ? 'tw-opacity-80 tw-pointer-events-none' : ''
    ]"
  >
    <div class="tw-flex tw-items-center">
      <input
        v-model="model"
        type="radio"
        :name="item.id"
        :value="item.id"
        class="tw-mr-4 tw-flex-shrink-0"
      >
  
      <div class="tw-flex tw-flex-col tw-gap-2 tw-select-none tw-flex-1">
        <div class="tw-flex tw-justify-between">
          <div class="tw-flex tw-gap-2">
            <div v-if="item.image">
              <img :src="iconSrc">
            </div>
      
            <span
              class="tw-font-atten"
              :class="isOnboardingRedesign ? 'tw-text-lg' : 'tw-text-base'"
            >
              {{ item.name }}
            </span>
          </div>
  
          <div
            v-if="item.mostpopular || item.bestdeal"
            :class="[
              model === item.id ? 'tw-bg-[#1A6A72]' : 'tw-bg-[#1A6A72]/60',
              {'tw-uppercase tw-text-[10px]': !isOnboardingRedesign},
              {'tw-text-sm md:tw-text-lg lg:tw-text-sm tw-tracking-wide': isOnboardingRedesign}
            ]"
            class="tw-bg-[#1A6A72] tw-text-white tw-py-1 tw-px-3 tw-rounded-md tw-leading-normal"
          >
            {{
              item.mostpopular
                ? 'Most Popular'
                : item.bestdeal ? 'Best Deal' : ''
            }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="item.description"
    >
      <p
        class="tw-mb-2"
        :class="{
          'tw-whitespace-pre-wrap': item.description.includes('\n'),
          'tw-max-w-[400px] tw-text-sm md:tw-text-lg': isOnboardingRedesign
        }"
      >{{ displayedDescription }}</p>

      <span
        class="tw-inline-block tw-font-thin tw-text-sm tw-text-[#1A6A72] tw-underline tw-cursor-pointer"
        :class="{'tw-text-sm md:tw-text-lg': isOnboardingRedesign}"
        @click.prevent="isDescriptionVisible = !isDescriptionVisible"
      >
        Show {{ isDescriptionVisible ? 'less' : 'more' }}
      </span>
    </div>
  </label>
  <label
    v-else
    class="
      tw-border-2 tw-border-solid tw-relative
      hover:tw-border-lavender-purple
      tw-py-3 tw-px-5 tw-rounded-lg
      tw-flex  tw-items-start
      tw-overflow-hidden
      tw-cursor-pointer
    "
    :class="[
      model === item.id ? 'tw-border-lavender-purple' : 'tw-border-silver-sand',
      disabled ? 'tw-opacity-80 tw-pointer-events-none' : ''
    ]"
  >
    <input
      v-model="model"
      type="radio"
      name="foo"
      :value="item.id"
      class="tw-mr-5 tw-flex-shrink-0"
    >

    <div class="tw-flex tw-flex-col tw-gap-2 tw-select-none">
      <span class="tw-text-base tw-font-atten-medium">{{ item.name }}</span>

      <div
        v-if="item.description"
        class="mb-3"
      >
        <p
          class="tw-font-thin tw-text-sm tw-leading-none tw-m-0"
          :class="{
            'tw-line-clamp-2': !isDescriptionVisible
          }"
        >
          {{ item.description }}
        </p>

        <span
          class="tw-inline-block tw-font-thin tw-text-sm tw-text-ocean-depths tw-underline tw-cursor-pointer"
          @click.prevent="isDescriptionVisible = !isDescriptionVisible"
        >
          {{ isDescriptionVisible ? 'Less' : 'More' }} Details
        </span>
      </div>

      <p
        v-if="item.pricingstatement"
        class="tw-leading-none tw-font-atten-bold tw-m-0"
      >{{ item.pricingstatement }}</p>
    </div>

    <div
      class="tw-w-[50px] tw-flex-shrink-0 tw-bg-cover tw-bg-no-repeat"
      :class="[
        item.image ? 'tw-h-[70px]' : ''
      ]"
      :style="{
        backgroundImage: `url(${item.image})`
      }"
    >
    </div>

    <div
      v-if="item.mostpopular || item.bestdeal"
      class="tw-absolute tw-text-[10px] tw-bg-tangerine-dream tw-text-white tw-py-1 tw-px-3 tw-right-0 tw-uppercase"
    >
      {{
        item.mostpopular
          ? 'Most Popular'
          : item.bestdeal ? 'Best Deal' : ''
      }}
    </div>
  </label>
</template>

<script>
import { mapState } from 'vuex';
import IconBiWeeklyPatch from '@/assets/images/treatments/biweekly-patch.svg';
import IconPills from '@/assets/images/treatments/pills.svg';
import IconBodyCream from '@/assets/images/treatments/body-cream.svg';

export default {
  props: {
    value: {
      type: [Boolean, String],
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isDescriptionVisible: false
    }
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    iconSrc() {
      switch (this.item.id) {
        case 'patch':
          return IconBiWeeklyPatch;
        case 'pill':
          return IconPills;
        case 'cream':
          return IconBodyCream;
        default:
          return '';
      }
    },
    displayedDescription() {
      const descriptionText = this.item?.description || '';
      const hasMoreContent = descriptionText.includes('\n');
      if (!hasMoreContent || this.isDescriptionVisible) {
        return descriptionText;
      } else {
        const newlineIndex = descriptionText.indexOf('\n');
        return newlineIndex !== -1 ? descriptionText.substring(0, newlineIndex) : descriptionText;
      }
    },
  },
}
</script>

<style lang="scss">
  input[type="radio"]{
  appearance: none;
  border: 1px solid #d3d3d3;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  content: none;
  outline: none;
  margin: 0;
  background-color: #d3d3d3;
}

input[type="radio"]:checked {
  appearance: none;
  outline: none;
  padding: 0;
  content: none;
  border: none;
}

input[type="radio"]:checked::before{
  position: absolute;
  color: white !important;
  content: "";
  border: 1px solid #a783ff;
  background: #a783ff;
  font-weight: bolder;
  font-size: 10px;
  border-radius: 100%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image:url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='white'%3e%3cpath d='M9 21.035l-9-8.638 2.791-2.87 6.156 5.874 12.21-12.436 2.843 2.817z'/%3e%3c/svg%3e");
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: center;
}

.redesign {
  input[type="radio"] {
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    content: none;
    outline: none;
    margin: 0;
    background-color: transparent;
  }

  input[type="radio"]:checked::before {
    position: absolute;
    color: white !important;
    content: "";
    font-weight: bolder;
    font-size: 10px;
    border-radius: 100%;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image:url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='white'%3e%3cpath d='M9 21.035l-9-8.638 2.791-2.87 6.156 5.874 12.21-12.436 2.843 2.817z'/%3e%3c/svg%3e") !important;
    background-size: 60% !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    border: 1px solid $primary;
    background: $primary;
  }
}
</style>